import { AddButton, SaveButton } from "components/Buttons"
import { ActionsDropdown } from "components/Dropdowns"
import ModalComponent from "components/Modals"
import PageMetaTags from "components/PageMetaTags"
import Table from "components/Table"
import { ADMIN_TYPE, BUSINESS_UNIT_TYPE, USER_TYPE } from "constants/people"
import CreateUserForm from "containers/People/createUserForm"
import HeaderLine from "containers/People/headerLine"
import peopleListColumn from "containers/People/peopleListColumns"
import React, { useEffect, useState, useRef } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { Card, CardBody, Col, Container, Modal, Row } from "reactstrap"
import {
  createAdmin,
  createMetaTag,
  createUser,
  deletePendingUsers,
  deleteUser,
  getBusinessUnits,
  getCustomers,
  getMetaTags,
  getRoles,
  hideAddTagModal,
  hideBulkModal,
  hideCreateModal,
  hideDeletePendingUsersModal,
  hideDeleteUserModal,
  hideRemoveUserTagModal,
  hideUserBlockStatusModal,
  openDeletePendingUsersModal,
  openDeleteUserModal,
  openUserBlockStatusModal,
  resetBusinessUnits,
  resetCustomers,
  resetMetaTags,
  resetRoles,
  sendInvite,
  setSelectedCustomer,
  setUserBlockStatus,
  showAddTagModal,
  showBulkModal,
  showCreateModal,
  showRemoveUserTagModal,
} from "store/actions"
import { getUpdatedCheckedItemsList } from "utils"
import XLSX from "xlsx"
import AddTagsForm from "./addTagsForm"
import MultipleUserForm from "./multipleUserForm"
import ViewModal from "./viewModal"
import { shouldDisplaySSN } from "./utils"
import AddSSNForm from "./addSSNForm"
import RemoveUserTagsForm from "./removeUserTagsForm"
import DeletePendingUsersModal from "./deletePendingUsersModal"
import DeleteUserModal from "./deleteUserModal"
import UserStatusModal from "./userStatusModal"
import { GET_CUSTOMER_URL } from "helpers/url_helper"
import { get } from "helpers/api_helper"

const People = props => {
  const defaultSorted = [
    {
      dataField: "registered_at",
      order: "desc",
    },
  ]
  const [inviteModal, setInviteModal] = useState(false)
  const [defaultOrder, setDefaultOrder] = useState({
    o: defaultSorted[0].dataField,
    od: defaultSorted[0].order,
  })
  const [checkedItems, setCheckedItems] = useState([])
  const [clickedUserId, setClickedUserId] = useState(null)
  const [filterFormValues, setFilterFormValues] = useState()
  const [bulkUsers, setBulkUsers] = useState([])
  const [viewContactModal, setViewContactModal] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [ssnModalIsOpen, setSsnModalIsOpen] = useState(false)
  const [selectedUser, setSelectedUser] = useState(null)
  const [selectUsersIsLoading, setSelectUsersIsLoading] = useState(false)

  const usersCSVFile = useRef(null)

  const handlePageChange = page => {
    props.getCustomers({
      page: page,
      ...filterFormValues,
      ...defaultOrder,
      dashboard: true,
    })
    setCurrentPage(page)
  }

  function handleSort(type, { sortField, sortOrder }) {
    props.getCustomers({
      dashboard: true,
      page: 1,
      o: sortField,
      od: sortOrder,
      ...filterFormValues,
    })
    setDefaultOrder({ o: sortField, od: sortOrder })
    setCurrentPage(1)
  }

  function handleFilterUsers(values) {
    let filterValues = { ...values }
    let filters = []
    if (values.active) {
      filters.push("active")
    }
    if (values.pending) {
      filters.push("pending")
    }
    filterValues["filters"] = filters

    setFilterFormValues(filterValues)
    setCheckedItems([])
    setCurrentPage(1)
    props.getCustomers({ ...filterValues, ...defaultOrder, dashboard: true })
  }

  const handleCheckItem = (item, checked) => {
    let checkedItemsList = getUpdatedCheckedItemsList(
      item,
      checked,
      checkedItems
    )
    setCheckedItems(checkedItemsList)
  }

  const handleCheckAllItems = (items, checked) => {
    let list = [...checkedItems]
    if (checked) {
      for (let i = 0; i < items.length; i++) {
        if (!list?.includes(items[i]?.id)) {
          list.push(items[i].id)
        }
      }
    } else {
      list = list.filter(itemId => !items.some(item => item.id === itemId))
    }
    setCheckedItems(list)
  }

  const onViewContact = item => {
    setClickedUserId(item)
    props.setSelectedCustomer(item)
    // setViewContactModal(true)
    props.history.push(`/profile/${item?.id}`)
  }

  const onAddTag = item => {
    if (item) {
      setClickedUserId(item?.id)
    } else {
      setClickedUserId(null)
    }
    props.showAddTagModal()
  }

  const onRemoveTag = item => {
    if (item) {
      setClickedUserId(item?.id)
    } else {
      setClickedUserId(null)
    }
    props.showRemoveUserTagModal()
  }

  const onSendInvite = item => {
    setInviteModal(true)
    setClickedUserId(item.id)
  }

  const onSendBulkInvite = () => {
    setInviteModal(true)
    setClickedUserId(null)
  }

  const onSendEmail = item => {
    if (item) {
      localStorage.setItem("commUsers", JSON.stringify([item?.id]))
    } else {
      localStorage.setItem("commUsers", JSON.stringify(checkedItems))
    }
    props.history.push(`/add-custom-email`)
  }

  const onSendNotification = item => {
    if (item) {
      localStorage.setItem("commUsers", JSON.stringify([item?.id]))
    } else {
      localStorage.setItem("commUsers", JSON.stringify(checkedItems))
    }
    props.history.push(`/add-notification`)
  }

  const onDeleteUser = item => {
    setSelectedUser(item)
    props.openDeleteUserModal()
  }

  const onBlockedStatusChange = item => {
    setSelectedUser(item)
    props.openUserBlockStatusModal()
  }

  const actions = [
    {
      name: "View",
      onClick: onViewContact,
      icon: "bx bx-show-alt",
      isAvailable: true,
    },
    {
      name: "Add Tag(s)",
      onClick: onAddTag,
      icon: "bx bx-purchase-tag",
      isAvailable: true,
    },
    {
      name: "Remove Tag(s)",
      onClick: onRemoveTag,
      icon: "bx bxs-tag-x",
      isAvailable: true,
    },
    {
      name: "Send Invite",
      onClick: onSendInvite,
      icon: "bx bx-notification",
      isAvailable: true,
    },
    {
      name: "Send Email",
      onClick: onSendEmail,
      icon: "bx bx-mail-send",
      isAvailable: true,
    },
    {
      name: "Send Notification",
      onClick: onSendNotification,
      icon: "bx bx-send",
      isAvailable: true,
    },
    {
      name: "Delete User",
      onClick: onDeleteUser,
      icon: "bx bx-trash",
      isAvailable: true,
    },
    {
      name: "Set User as Inactive",
      onClick: onBlockedStatusChange,
      icon: "bx bx-x-circle",
      isAvailable: true,
      checkBlockStatus: true,
    },
  ]

  const bulkActions = [
    {
      name: "Add Tag(s)",
      onClick: onAddTag,
      icon: "bx bx-purchase-tag",
      isAvailable: checkedItems.length > 0,
    },
    {
      name: "Remove Tag(s)",
      onClick: onRemoveTag,
      icon: "bx bxs-tag-x",
      isAvailable: checkedItems.length > 0,
    },
    {
      name: "Send Invite",
      onClick: onSendBulkInvite,
      icon: "bx bx-notification",
      isAvailable: checkedItems.length > 0,
    },
    {
      name: "Send Email",
      onClick: onSendEmail,
      icon: "bx bx-mail-send",
      isAvailable: checkedItems.length > 0,
    },
    {
      name: "Send Notification",
      onClick: onSendNotification,
      icon: "bx bx-send",
      isAvailable: checkedItems.length > 0,
    },
    {
      name: "Delete Pending User(s)",
      onClick: () => {
        props?.openDeletePendingUsersModal()
      },
      icon: "bx bx-trash",
      isAvailable: checkedItems.length > 0,
    },
  ]

  const addSSN = item => {
    setSelectedUser(item)
    setSsnModalIsOpen(true)
  }

  const handleSendInviteSubmit = () => {
    let body = {
      users: clickedUserId ? [clickedUserId] : checkedItems,
      vendor_id: props.vendorId,
    }
    props.sendInvite(body)
    setInviteModal(false)
  }

  useEffect(() => {
    props.getMetaTags()
    props.getBusinessUnits()
    props.getCustomers({ ...defaultOrder, dashboard: true, page: 1 })
    props.getRoles()
    return () => {
      props.resetCustomers()
      props.resetMetaTags()
      props.resetBusinessUnits()
      props.resetRoles()
    }
  }, [])

  const handleCreateTag = tagLabel => {
    props.createMetaTag({
      values: {
        vendor_id: props.vendorId,
        tag: tagLabel,
        invisible: false,
        business_unit_id: null,
      },
    })
  }

  const mapTags = (tags = []) => {
    return tags
      .map(tag => {
        if (tag.value || tag.value === 0) {
          return tag.value
        } else {
          const matchingTag = props.metaTags.find(
            metaTag => metaTag.tag === tag.label
          )
          return matchingTag ? matchingTag.id : null
        }
      })
      .filter(tag => !!tag)
  }

  const handleSubmit = values => {
    if (values.people_type === ADMIN_TYPE) {
      props.createAdmin({
        first_name: values.first_name,
        last_name: values.last_name,
        display_name: values.display_name,
        email: values.email_address,
        phone: values.phone_number,
        vendor_id: values.vendor_id,
        type: values.assign_acount_type,
        business_unit_id:
          values.assign_acount_type === BUSINESS_UNIT_TYPE
            ? values.business_unit
            : null,
        roles: values.assign_roles,
        send_invite: values.send_invite,
        tags: mapTags(values.tags),
        country_code: values?.country_code,
      })
    } else {
      props.createUser({
        tags: mapTags(values.tags),
        users: [
          {
            first_name: values.first_name,
            last_name: values.last_name,
            display_name: values.display_name,
            email: values.email_address,
            phone: values.phone_number,
            country_code: values?.country_code,
            ...(shouldDisplaySSN(props?.vendorId)
              ? { last_4_ssn: values?.last_4_ssn }
              : {}),
          },
        ],
        business_unit_id: null,
        vendor_id: values.vendor_id,
        send: values.send_invite,
      })
    }
  }

  const handleCSVUpload = event => {
    const { files } = event.target
    if (files.length > 0) {
      const reader = new FileReader()
      reader.onload = ({ target: { result } }) => {
        const wb = XLSX.read(result, { type: "binary" })
        let users = []
        Object.keys(wb.Sheets).forEach(key => {
          if (!wb.Sheets[key]) return

          const sheet = shouldDisplaySSN(props?.vendorId)
            ? XLSX.utils.sheet_to_json(wb.Sheets[key], {
                header: [
                  "firstName",
                  "lastName",
                  "email",
                  "display_name",
                  "phone",
                  // "country_code",
                  // "last_4_ssn",
                ],
              })
            : XLSX.utils.sheet_to_json(wb.Sheets[key], {
                header: [
                  "firstName",
                  "lastName",
                  "email",
                  "display_name",
                  "phone",
                  // "country_code",
                  // "last_4_ssn",
                ],
              })

          const sheetData = sheet.map(user => ({
            ...user,
            firstName: user.firstName != null ? String(user.firstName) : "",
            lastName: user.lastName != null ? String(user.lastName) : "",
            display_name:
              user.display_name != null ? String(user.display_name) : "",
            email: typeof user.email === "string" ? user.email.trim() : "",
          }))
          
          users = [...users, ...sheetData]
        })
        // setBulkUsers(users)
        users.shift()
        setBulkUsers(users)
        props.showBulkModal()
        event.target.value = ""
        event.target.files = null
      }

      reader.readAsBinaryString(files[0])
    }
  }

  const handleCreateMultipleUsers = values => {
    props.createUser({
      business_unit_id: null,
      vendor_id: props.vendorId,
      send: values.sendInvite,
      tags: mapTags(values.tags),
      users: values.users.map(user => ({
        first_name: user.firstName,
        last_name: user.lastName,
        display_name: user.display_name,
        email: user.email,
        phone: user.phone,
        country_code: user?.country_code,
        ...(shouldDisplaySSN(props?.vendorId)
          ? { last_4_ssn: user?.last_4_ssn }
          : {}),
      })),
    })
  }

  const onSelectAllUsers = async () => {
    setSelectUsersIsLoading(true)

    try {
      const items = await get(GET_CUSTOMER_URL, {
        params: { ...filterFormValues, not_paginated: true },
      })
      const itemIds = items?.map(item => item?.id)
      setCheckedItems(itemIds)
    } catch (error) {
      console.error("Failed to fetch selected items", error)
    } finally {
      setSelectUsersIsLoading(false)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <PageMetaTags title={"Users list"} />
        <Container fluid>
          <HeaderLine
            onSubmit={values => handleFilterUsers(values)}
            setFilterFormValues={setFilterFormValues}
            resetCheckedItems={setCheckedItems}
            usersCSVFile={usersCSVFile}
            filters={filterFormValues}
            order={defaultOrder}
          />
          <Card className="mt-3">
            <CardBody className="pt-2 px-2">
              <Row className="justify-content-between mb-2">
                <Col xs="auto">
                  <ActionsDropdown
                    fullWidth={true}
                    label={"Bulk actions"}
                    actionsList={bulkActions}
                    menuPosition={"start"}
                    color="success"
                  />
                </Col>
                <Col xs={1} style={{ minWidth: "fit-content" }}>
                  <AddButton
                    fullWidth={true}
                    content={"Add user"}
                    onClick={props.showCreateModal}
                  />
                </Col>
              </Row>
              {!!props?.total_items && (
                <Row className="mb-2">
                  {props?.total_items !== checkedItems?.length && (
                    <Col xs="auto">
                      <SaveButton
                        type="button"
                        content={`Select All users (${props?.total_items})`}
                        onClick={onSelectAllUsers}
                        loading={selectUsersIsLoading}
                      />
                    </Col>
                  )}

                  {checkedItems?.length > 0 && (
                    <Col xs="auto">
                      <SaveButton
                        type="button"
                        content="Deselect All users"
                        color="light"
                        onClick={() => setCheckedItems([])}
                      />
                    </Col>
                  )}
                </Row>
              )}
              {checkedItems?.length > 0 && (
                <Row>
                  <Col>
                    <label>
                      {props?.total_items === checkedItems?.length
                        ? `All users selected (${checkedItems?.length})`
                        : `${checkedItems?.length} users selected`}
                    </label>
                  </Col>
                </Row>
              )}
              <Row>
                <Col>
                  {!!props.businessUnits &&
                    !!props.metaTags &&
                    !props?.loading && (
                      <Table
                        columns={peopleListColumn(
                          shouldDisplaySSN(props?.vendorId)
                            ? [
                                ...actions,
                                {
                                  name: "Add last 4 of the SSN",
                                  onClick: addSSN,
                                  icon: "mdi mdi-security",
                                  isAvailable: true,
                                },
                              ]
                            : actions
                        )}
                        onTableSort={handleSort}
                        data={props.customers}
                        withCheckboxes={true}
                        onCheckItem={handleCheckItem}
                        onCheckAllItems={handleCheckAllItems}
                        noTableDataMessage={"No users to display"}
                        loadingData={props.loading}
                        paginationData={{
                          current_page: props.current_page,
                          last_page: props.last_page,
                          total_items: props.total_items,
                          items_per_page: props.items_per_page,
                          from: props.from,
                          to: props.to,
                          first_page: 1,
                        }}
                        onPageChange={handlePageChange}
                        selectedItems={checkedItems}
                        hideSelectAllRows={true}
                      />
                    )}
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Container>
        <ModalComponent
          open={ssnModalIsOpen}
          onClose={() => setSsnModalIsOpen(false)}
          onSubmit={props.showCreateModal}
          title={
            "Add Last 4 of SSN to " +
            selectedUser?.first_name +
            " " +
            selectedUser?.last_name
          }
        >
          <AddSSNForm
            hideSsnModal={() => {
              setSelectedUser(null)
              setSsnModalIsOpen(false)
            }}
            selectedUser={selectedUser}
          />
        </ModalComponent>
        <ModalComponent
          open={props.isCreateModalOpen}
          onClose={props.hideCreateModal}
          onSubmit={props.showCreateModal}
          submitText={"Create User"}
          title={"Add New User"}
          size="lg"
        >
          <CreateUserForm
            onSubmit={handleSubmit}
            businessUnits={props.businessUnits}
            roles={props.roles}
            metaTags={props.metaTags}
            initialValues={{
              vendor_id: props.vendorId,
              people_type: USER_TYPE,
              send_invite: false,
            }}
            onTagCreate={handleCreateTag}
            loading={props.loading}
            vendorId={props?.vendorId}
          />
        </ModalComponent>

        <ModalComponent
          open={props.isBulkModalOpen}
          onClose={props.hideBulkModal}
          onSubmit={props.showBulkModal}
          submitText={"Create multiple user"}
          title={"Create multiple user"}
          size="xl"
        >
          <MultipleUserForm
            loading={props.loading}
            onSubmit={handleCreateMultipleUsers}
            initialValues={{ sendInvite: false }}
            users={bulkUsers}
            metaTags={props.metaTags}
            onTagCreate={handleCreateTag}
            vendorId={props?.vendorId}
          />
        </ModalComponent>

        <ModalComponent
          open={inviteModal}
          onClose={() => setInviteModal(false)}
          title={"Send Invite"}
        >
          <Row>
            <Col>
              <p>
                Would you like to send the app invite to{" "}
                {clickedUserId ? "1" : checkedItems?.length} selected users?
              </p>
              <p>
                The app invite will only be sent to Pending users, if the users
                are already Active, they will not receive an app invite.
              </p>
            </Col>
          </Row>
          <Row className="justify-content-end">
            <Col xs="auto">
              <SaveButton
                type="button"
                color="danger"
                content={"Cancel"}
                onClick={() => setInviteModal(false)}
              />
            </Col>
            <Col xs="auto">
              <SaveButton
                type="button"
                content={"Send"}
                onClick={handleSendInviteSubmit}
              />
            </Col>
          </Row>
        </ModalComponent>
        <ModalComponent
          open={props.isAddTagModalOpen}
          onClose={props.hideAddTagModal}
          title={"Add Tags"}
        >
          <AddTagsForm
            selectedUsers={clickedUserId ? [clickedUserId] : checkedItems}
            callbackParams={{
              ...filterFormValues,
              ...defaultOrder,
              page: currentPage,
            }}
            resetSelectedUsers={() => setCheckedItems([])}
          />
        </ModalComponent>
        <ModalComponent
          open={props.removeUserTagModalIsOpen}
          onClose={props.hideRemoveUserTagModal}
          title={"Remove Tags"}
        >
          <RemoveUserTagsForm
            selectedUsers={clickedUserId ? [clickedUserId] : checkedItems}
            callbackParams={{
              ...filterFormValues,
              ...defaultOrder,
              page: currentPage,
            }}
            resetSelectedUsers={() => setCheckedItems([])}
          />
        </ModalComponent>
        <ModalComponent
          open={props.deletePendingUsersModalIsOpen}
          onClose={props.hideDeletePendingUsersModal}
          title={"Delete Pending Users"}
        >
          <DeletePendingUsersModal
            selectedUsers={checkedItems}
            handleDeletePendingUsers={() => {
              props?.deletePendingUsers({
                users: checkedItems,
                vendor_id: props?.vendorId,
              })
              setCheckedItems([])
            }}
          />
        </ModalComponent>
        <ModalComponent
          open={props.deleteUserModalIsOpen}
          onClose={() => {
            props.hideDeleteUserModal()
            setSelectedUser(null)
          }}
          title={`Delete User ${
            selectedUser?.full_name ? `'${selectedUser?.full_name}'` : ""
          }`}
        >
          <DeleteUserModal
            handleDeleteUser={() => {
              props?.deleteUser({
                userId: selectedUser?.id,
                callbackParams: {
                  ...filterFormValues,
                  ...defaultOrder,
                  page: currentPage,
                },
              })
            }}
            hideDeleteUserModal={() => {
              props.hideDeleteUserModal()
              setSelectedUser(null)
            }}
          />
        </ModalComponent>
        <ModalComponent
          open={props.setUserBlockStatusModalIsOpen}
          onClose={() => {
            props.hideUserBlockStatusModal()
            setSelectedUser(null)
          }}
          title={
            selectedUser?.blocked === 1
              ? `Revert Inactive User ${
                  selectedUser?.full_name ? `'${selectedUser?.full_name}'` : ""
                }`
              : `Set User ${
                  selectedUser?.full_name ? `'${selectedUser?.full_name}' ` : ""
                }as inactive`
          }
        >
          <UserStatusModal
            hideStatusChangeModal={() => {
              props.hideUserBlockStatusModal()
              setSelectedUser(null)
            }}
            handleStatusChange={() => {
              props?.setUserBlockStatus({
                userId: selectedUser?.id,
                callbackParams: {
                  ...filterFormValues,
                  ...defaultOrder,
                  page: currentPage,
                },
                data: {
                  blocked:
                    selectedUser?.blocked !== 1
                      ? 1
                      : selectedUser?.has_password
                      ? 0
                      : 2,
                },
              })
            }}
            isInactive={selectedUser?.blocked === 1}
          />
        </ModalComponent>
        <Modal
          isOpen={viewContactModal}
          toggle={() => {
            setViewContactModal(false)
          }}
          scrollable={true}
          centered={true}
          size="md"
        >
          <ViewModal
            onClose={() => {
              setViewContactModal(false)
            }}
            callbackParams={{
              ...filterFormValues,
              ...defaultOrder,
              page: currentPage,
            }}
          />
        </Modal>
        <input
          ref={usersCSVFile}
          onChange={handleCSVUpload}
          type="file"
          accept=".xlsx,.xls,.csv,.ods"
          className="d-none"
        />
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  customers: state.people.customers,
  current_page: state.people.current_page,
  last_page: state.people.last_page,
  total_items: state.people.total_items,
  items_per_page: state.people.items_per_page,
  from: state.people.from,
  to: state.people.to,
  loading: state.people.loading,
  isCreateModalOpen: state.people.isCreateModalOpen,
  isBulkModalOpen: state.people.isBulkModalOpen,
  businessUnits: state.businessUnits.businessUnits,
  metaTags: state.Tags.metaTags,
  vendorId: state.Login.vendorId,
  roles: state.Profile.roles,
  isAddTagModalOpen: state.people.isAddTagModalOpen,
  removeUserTagModalIsOpen: state.people.removeUserTagModalIsOpen,
  deletePendingUsersModalIsOpen: state.people.deletePendingUsersModalIsOpen,
  deleteUserModalIsOpen: state.people.deleteUserModalIsOpen,
  setUserBlockStatusModalIsOpen: state.people.setUserBlockStatusModalIsOpen,
})

const mapDispatchToProps = dispatch => ({
  getCustomers: values => dispatch(getCustomers(values)),
  resetCustomers: values => dispatch(resetCustomers(values)),
  getMetaTags: values => dispatch(getMetaTags(values)),
  getBusinessUnits: values => dispatch(getBusinessUnits(values)),
  resetMetaTags: () => dispatch(resetMetaTags()),
  resetBusinessUnits: () => dispatch(resetBusinessUnits()),
  sendInvite: values => dispatch(sendInvite(values)),
  getRoles: () => dispatch(getRoles()),
  resetRoles: () => dispatch(resetRoles()),
  createMetaTag: values => dispatch(createMetaTag(values)),
  createUser: user => dispatch(createUser(user)),
  createAdmin: admin => dispatch(createAdmin(admin)),
  showCreateModal: () => dispatch(showCreateModal()),
  hideCreateModal: () => dispatch(hideCreateModal()),
  showBulkModal: () => dispatch(showBulkModal()),
  hideBulkModal: () => dispatch(hideBulkModal()),
  showAddTagModal: () => dispatch(showAddTagModal()),
  hideAddTagModal: () => dispatch(hideAddTagModal()),
  setSelectedCustomer: values => dispatch(setSelectedCustomer(values)),
  showRemoveUserTagModal: () => dispatch(showRemoveUserTagModal()),
  hideRemoveUserTagModal: () => dispatch(hideRemoveUserTagModal()),
  deletePendingUsers: values => dispatch(deletePendingUsers(values)),
  openDeletePendingUsersModal: () => dispatch(openDeletePendingUsersModal()),
  hideDeletePendingUsersModal: () => dispatch(hideDeletePendingUsersModal()),
  openDeleteUserModal: () => dispatch(openDeleteUserModal()),
  hideDeleteUserModal: () => dispatch(hideDeleteUserModal()),
  deleteUser: values => dispatch(deleteUser(values)),
  openUserBlockStatusModal: () => dispatch(openUserBlockStatusModal()),
  hideUserBlockStatusModal: () => dispatch(hideUserBlockStatusModal()),
  setUserBlockStatus: values => dispatch(setUserBlockStatus(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(People))
